var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgActionOppsKiva(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 42.7",
    style: {
      enableBackground: "new 0 0 100 42.7"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4FAF4E;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.8,2.5h-8v37.9h8V2.5z M31,40.4h8V13.8h-8V40.4z M51.6,40.4h9.3l9.3-26.6h-8c0,0-4.4,14.5-5.6,19.1h-0.1 c-1.3-4.6-5.7-19.1-5.7-19.1h-8.5L51.6,40.4z M98.3,13.8h-7.8v3.6C89.2,14.6,86,13,82.4,13c-6.6,0-11.8,5.4-11.8,14 c0,8.7,5,14,11.4,14c4.5,0,7.2-2.2,8.5-4.6v3.9h7.8V13.8z M90.3,27.8c0,4.9-3,7.2-6,7.2c-3.3,0-5.4-3.4-5.4-7.9s2.2-7.9,5.7-7.9 c2.8,0,5.8,2.3,5.8,7.2L90.3,27.8L90.3,27.8z M11.8,26.5c12.9,0,15.9-10.8,15.9-12.6h-1.1c-12.9,0-15.9,10.8-15.9,12.6H11.8z  M10.7,27.5c0,2,2.2,13,16.1,13H28c0-2-2.2-13-16.1-13H10.7z M39.8,6.5C39.8,4,38,1.8,35,1.8S30.2,4,30.2,6.5s1.8,4.7,4.8,4.7 S39.8,9,39.8,6.5"
  })));
}

export default SvgActionOppsKiva;